<template>
	<div>
		<ul class="settings-subnav">
			<li>
				<button type="button" :class="{ active: sub === 'clients' }" @click="sub = 'clients'">
					<i class="fas fa-users me-1"></i> Clients
				</button>
			</li>
			<li>
				<button type="button" :class="{ active: sub === 'municipalities' }" @click="sub = 'municipalities'">
					<i class="fas fa-city me-1"></i> Municipalities
				</button>
			</li>
		</ul>

		<ClientsSettings v-if="sub === 'clients'" />
		<MunicipalitiesSettings v-if="sub === 'municipalities'" />
	</div>
</template>

<script>
import ClientsSettings from './ClientsSettings.vue'
import MunicipalitiesSettings from './MunicipalitiesSettings.vue'

// Per-module settings for the main sidebar sections (Clients page,
// Municipalities page, …) — add a new subnav pill when another sidebar
// module grows its own settings.
export default {
	name: 'ModulesSettings',
	components: { ClientsSettings, MunicipalitiesSettings },
	data() {
		return {
			sub: 'clients',
		}
	},
}
</script>
